import { AvatarWrapper } from '@/components/ui/avatar';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, TableUser, TableUserContent, TableUserTitle } from '@/components/ui/table';
import React from 'react';
import { AiOutlineTrophy } from 'react-icons/ai';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

const PLAYFUL_HIGHLIGHT_CLASSNAME = '[&>td]:bg-[var(--color-mission)] [&>th]:!bg-[var(--color-mission)]';

export function TableUsers({ users, session }) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const tableHeaders = [
    {
      text: 'Posição',
      width: 56,
      align: 'left'
    },
    {
      text: '',
      width: 36,
      align: 'left'
    },
    {
      text: 'Estudante',
      width: null,
      align: 'left'
    },
    {
      text: 'Unidade escolar',
      width: 200,
      align: 'left'
    },
    {
      text: 'GRE',
      width: 160,
      align: 'left'
    },
    {
      text: 'Pontuação total',
      width: 128,
      align: 'right'
    }
  ];

  return (
    <Table className="min-w-[720px]">
      <TableHeader>
        <TableRow>
          {tableHeaders.map((header, index) => (
            <TableHead
              key={index}
              scope="col"
              className={`text-${header.align ?? 'left'}`}
              style={{ width: header.width ? `${header.width}px` : 'auto' }}
            >
              {header.text}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>

      <TableBody>
        {users?.map((item, i) => (
          <TableRow
            highlight={item?.id === session?.user?.id}
            highlightClassName={isPlayfulStudentTheme ? PLAYFUL_HIGHLIGHT_CLASSNAME : undefined}
          >
            <TableHead scope="row">{i + 1}</TableHead>
            <TableCell>
              {i === 0 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#FFD661]"
                />
              )}
              {i === 1 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#8894AC]"
                />
              )}
              {i === 2 && (
                <AiOutlineTrophy
                  size={16}
                  className="text-[#D3681A]"
                />
              )}
            </TableCell>
            <TableCell>
              <TableUser>
                <AvatarWrapper
                  size="xs"
                  src={item?.image?.url}
                  text={item?.name}
                />

                <TableUserContent>
                  <TableUserTitle>{item?.name}</TableUserTitle>
                </TableUserContent>
              </TableUser>
            </TableCell>
            <TableCell>
              <div
                className="w-[200px] truncate"
                title={item.institution}
              >
                {item.institution}
              </div>
            </TableCell>
            <TableCell>
              <div
                className="w-[160px] truncate"
                title={item.regional}
              >
                {item.regional}
              </div>
            </TableCell>
            <TableCell className="text-right">{item.score} pontos</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
